import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import { Modal, Box, Typography, Grid, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import templates from "views/Dashboard/Data/templates";

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh", // Ensures the modal takes full screen
    padding: theme.spacing(2),
  },
  modalContent: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    width: "80%",
    maxWidth: "800px", // Max width of modal
  },
  dialogTitle: {
    fontWeight: "600",
    fontSize: "1.25rem",
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  resourceTile: {
    height: "100%", // Ensure all tiles have the same height
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between", // To ensure the content inside each tile is spaced well
    alignItems: "center",
    textAlign: "center",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      boxShadow: theme.shadows[5],
      cursor: "pointer",
    },
  },
  cancelButton: {
    marginTop: theme.spacing(2),
    textTransform: "none",
  },
}));

const TaskDefinitionModal = ({ open, onClose, setTaskDefinition, setTone, setAudience, module_name, module_description, templatesOverride, selectedPersonas = [], setSelectedPersonas, multiSelect = false }) => {
  const classes = useStyles();

  const handleTemplateSelect = (template, templateHeading) => {
    if (multiSelect && setSelectedPersonas) {
      // Toggle persona selection
      if (selectedPersonas.includes(templateHeading)) {
        setSelectedPersonas(selectedPersonas.filter(p => p !== templateHeading));
      } else {
        setSelectedPersonas([...selectedPersonas, templateHeading]);
      }
    } else {
      // Set individual fields from template
      let taskDesc = template.taskDescription || "";
      
      if (module_name && module_description) {
        taskDesc = `Module name: ${module_name}\nModule description: ${module_description}\n\n${taskDesc}`;
      }
      
      setTaskDefinition(taskDesc);
      
      if (setTone && template.tone) {
        setTone(template.tone);
      }
      
      if (setAudience && template.audience) {
        setAudience(template.audience);
      }
      
      onClose();
    }
  };



  return (
    <Modal open={open} onClose={onClose} className={classes.modalRoot}>
      <Box className={classes.modalContent}>
        {/* Modal Title */}
        <Typography className={classes.dialogTitle}>
          {multiSelect ? 'Select Personas' : 'Templates'}
        </Typography>

        {/* Grid for Resource Tiles */}
        <Grid container spacing={3} justifyContent="center">
          {(templatesOverride || templates).map((template, index) => {
            const isSelected = multiSelect && selectedPersonas?.includes(template.heading);
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                  className={classes.resourceTile}
                  onClick={() => handleTemplateSelect(template, template.heading)}
                  style={{
                    backgroundColor: isSelected ? '#e8f0f2' : undefined,
                    border: isSelected ? '2px solid #435966' : undefined,
                  }}
                >
                  {/* Icon and Heading */}
                  <Box mb={2}>
                    <template.icon fontSize="large" style={{ color: isSelected ? '#435966' : undefined }} />
                  </Box>
                  <Typography variant="body1" style={{ fontWeight: isSelected ? 600 : 400 }}>
                    {template.heading}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {template.description}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {/* Action Buttons */}
        <Box textAlign="center" width="100%" display="flex" justifyContent="center" gap={2}>
          {multiSelect && (
            <Button
              onClick={onClose}
              color="quCreateColor"
              variant="contained"
              className={classes.cancelButton}
            >
              Done
            </Button>
          )}
          <Button
            onClick={onClose}
            color="quCreateColor"
            variant="outlined"
            className={classes.cancelButton}
          >
            {multiSelect ? 'Cancel' : 'Cancel'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TaskDefinitionModal;
